module.exports = __webpack_public_path__ + "img/ic_round-headset-mic.3d6faf65.svg";